/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { IUser } from 'src/interfaces';
// import { DataTableCellEditButton, RegularButton } from 'pg-ui-library';
import { DataTableCellEditButton, RegularButton, Loader, CommonInput, AlertAdapter } from 'pg-ui-library'; // Added Loader import here
import { useQuery } from '@tanstack/react-query';
import UserService from 'src/services/user.service';

import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { t } from 'i18next';
import { CompanyContainer, CompanyHeader, EmptyContainer, HeaderActions } from './styles';

import { ExternalModal } from './external-edit-modal';
import { AddExternalClientUserModal } from './external-client-modal';
import { BulkExternalClientUserModal } from './bulk-external-client-user-modal/bulk-external-client-user-modal';

const ExternalClientUsersTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageUser, setPageUser] = useState(1);
  const [limitUser, setLimitUser] = useState(10);
  const [sortByUser, setSortByUser] = useState('');
  const [sortDirectionUser, setSortDirectionUser] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [isOpenEditUser, setIsOpenEditUser] = useState(false);
  const [updateUser, setUpdateUser] = useState<IUser | undefined>(undefined);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [searchTerm, setsearchTerm] = useState('');

  const handlePageChange = (nPage: number) => {
    setPageUser(nPage);
  };

  const editButtonUserWrapper = (onClick: Function) => <DataTableCellEditButton onClick={() => onClick()} />;

  const handlePerRowsChange = async (newLimit: number, nPage: number) => {
    setPageUser(nPage);
    setLimitUser(newLimit);
  };

  const handleSortExternalUser = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortByUser(field);
    setSortDirectionUser(newSortDirection);
  };

  const onEdit = (user: IUser) => {
    setUpdateUser(user);
    setIsOpenEditUser(true);
  };

  const {
    data: users,
    refetch: refetchUsers,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers,
  } = useQuery(['external-client-users', pageUser, limitUser, sortByUser, sortDirectionUser, searchTerm], () =>
    UserService.getExternalClientUsers({
      page: pageUser,
      limit: limitUser,
      sortBy: sortByUser,
      sortDirection: sortDirectionUser,
      search: searchTerm,
    })
  );

  useEffect(() => {
    setTotalRows(users?.data?.meta?.totalItems || 0);
  }, [users]);

  const externalManagerUsersColumns: GridColDef[] = [
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 300,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => onEdit(row)}>
              {editButtonUserWrapper(() => onEdit(row))}
            </div>
          </div>
        );
      },
    },
  ];

  const handleResendPasswordSetupLinks = async () => {
    try {
      await UserService.resendExistingPasswordSetupLinks();
      AlertAdapter('Password setup links have been resent successfully.', 'success');
    } catch (error) {
      console.error(error);
      alert('Failed to resend password setup links.');
    }
  };
  return (
    <>
      <CompanyContainer>
        {updateUser && (
          <ExternalModal
            isOpen={isOpenEditUser}
            setIsOpen={setIsOpenEditUser}
            user={updateUser}
            onSuccess={() => {
              setIsOpenEditUser(false);
              refetchUsers();
            }}
          />
        )}

        <AddExternalClientUserModal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          onSuccess={refetchUsers}
        />

        <BulkExternalClientUserModal
          isOpen={isBulkModalOpen}
          onRequestClose={() => setIsBulkModalOpen(false)}
          onSuccess={refetchUsers}
        />

        <CompanyHeader>
          <h4>{t('settings.externalClientUsers')}</h4>

          <HeaderActions>
            <CommonInput
              id="searchQuery"
              name="searchQuery"
              placeholder="Search..."
              value={searchTerm}
              onChange={event => {
                let newValue = event.target.value;
                setsearchTerm(newValue);
              }}
              style={{
                width: '200px',
                marginRight: '10px',
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '5px',
              }}
              label=""
            />
            <RegularButton onClick={() => setIsModalOpen(true)}>{t('global.form.add')}</RegularButton>
            <RegularButton onClick={() => setIsBulkModalOpen(true)}>Bulk Upload</RegularButton>
            <RegularButton onClick={handleResendPasswordSetupLinks}>Resend Password Links</RegularButton>
          </HeaderActions>
        </CompanyHeader>
      </CompanyContainer>
      {isLoadingUsers || isFetchingUsers ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <div style={{ alignSelf: 'right', minWidth: '100%' }}>
          <DataGrid
            rows={users?.data?.items || []}
            columns={externalManagerUsersColumns}
            paginationMode="server"
            rowCount={users?.data?.meta?.totalItems || 0}
            paginationModel={{
              page: pageUser - 1,
              pageSize: limitUser,
            }}
            onPaginationModelChange={model => {
              setPageUser(model.page + 1);
              setLimitUser(model.pageSize);
            }}
            sx={{
              font: '14px Biotif',
              fontWeight: 'bold',
              '& .CommonHeaderClass': {
                color: '#9399B2',
                font: '16px Biotif',
                fontWeight: 'bold',
              },
              '& .first-column-cell': {
                paddingLeft: '200px',
              },
              '& .striped-row': {
                backgroundColor: '#F3F4F8',
                color: '#1B1D35',
              },
              minHeight: '150px',
              background: '#fff',
            }}
          />
        </div>
      )}
    </>
  );
};

export default ExternalClientUsersTab;
